import type { ModuleSlot, ModuleView } from "./types.js";

export const EQUIPMENT_SLOTS: ModuleSlot[] = ["weapon", "armor", "core", "sensor", "drive"];
export const MODULE_PAGE_SIZE = 12;
export interface ModuleFilters {
  slot: ModuleSlot | "all";
  tier: string;
  mfr: string;
  ownership: "all" | "free" | "equipped";
  search: string;
  sort: "tier" | "power" | "enhance";
}
export const initialModuleFilters = (): ModuleFilters => ({ slot: "all", tier: "all", mfr: "all", ownership: "all", search: "", sort: "tier" });
export function filterModules(modules: ModuleView[], filters: ModuleFilters, label: (module: ModuleView) => string) {
  const query = filters.search.trim().toLocaleLowerCase();
  const tiers = ["D", "C", "B", "A", "S"];
  return modules.filter(m => (filters.slot === "all" || m.slot === filters.slot) && (filters.tier === "all" || m.tier === filters.tier) && (filters.mfr === "all" || m.mfr === filters.mfr) && (filters.ownership === "all" || (filters.ownership === "free" ? !m.unitRowId : !!m.unitRowId)) && (!query || label(m).toLocaleLowerCase().includes(query)))
    .sort((a, b) => (filters.sort === "power" ? b.power - a.power : filters.sort === "enhance" ? b.enhance - a.enhance : tiers.indexOf(b.tier) - tiers.indexOf(a.tier)) || b.enhance - a.enhance || b.power - a.power || a.id.localeCompare(b.id));
}
